<template>
  <div class="parent-reward-main-container pb-sm-0 mx-2 mx-sm-3 mr-md-4 pm-3 pt-3">
    <div class="parent-rewards-list">
      <empty-module
        v-if="parentRewardsList.length == 0"
        :title="'You have not added any rewards yet.'"
        :icon="'card_giftcard'"
      />
      <reward-card
        v-for="(reward, index) in parentRewardsList"
        :customClass="'parent-reward-card'"
        :key="'parent-reward-' + index"
        :rewardData="{
          id: reward.id,
          name: reward.name,
          stars_required: reward.points_required,
          reward_type: null,
          attachment: null,
          available: reward.available,
          claimed: reward.claimed,
        }"
        :claimReward="claimReward"
        :canClaim="true"
        :starsBanked="availableStars"
        :sectionColor="'#B6D2D1'"
        :iconColor="'#6FA6A3'"
        :editReward="editReward"
        :deleteReward="deleteReward"
        :currencyWord="'Points'"
      ></reward-card>
    </div>
  </div>
</template>
<script>
import RewardCard from './rewardCard.vue';
import emptyModule from '@/components/general/emptyModule.vue';
export default {
  name: 'parent-reward',
  props: {
    parentRewardsList: {
      type: Array,
      defaul: [],
    },
    availableStars: {
      type: Number,
      default: 0,
    },
    editReward: {
      type: Function,
      value: () => {},
    },
    deleteReward: {
      type: Function,
      value: () => {},
    },
    claimReward: {
      type: Function,
      default: () => {
        return;
      },
    },
  },
  components: { RewardCard, emptyModule },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
  // beforeRouteEnter(to, from, next) {

  // }
};
</script>

<style scoped lang="scss">
.parent-reward-main-container {
  .parent-rewards-list {
    justify-content: center;
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    overflow-y: scroll;
    position: absolute;
    @media (min-width: 768px) {
      justify-content: center;
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      overflow: inherit;
      position: inherit;
    }
  }
}
</style>

<style>
.parent-reward-card {
  width: 302px;
}
</style>
